export default (state = [], action) => {
    switch (action.type) {
        case 'FETCH_ROLE':
            return action.payload;
        default:
            return state;
    }
}